import { Component, OnInit } from '@angular/core';
import { ReleaseNoteService } from '@app/core/services/release-note.service';
import { ReleaseNoteDto } from '@app/generated';
import { firstValueFrom } from 'rxjs';

export interface ReleaseGroup {
  version: string;
  date: string;
  notes: ReleaseNoteDto[];
}
@Component({
  selector: 'app-release-note',
  templateUrl: './release-note.component.html',
  styleUrls: ['./release-note.component.scss'],
  standalone: false,
})
export class ReleaseNoteComponent implements OnInit {
  releases: ReleaseNoteDto[] = [];
  groupedReleases: ReleaseGroup[] = [];

  constructor(private releaseNoteService: ReleaseNoteService) {}

  async ngOnInit(): Promise<void> {
    this.releaseNoteService.getAllReleaseNotes().subscribe({
      next: (data) => {
        this.releases = data.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        this.groupedReleases = this.groupByVersion(this.releases);
      },
      error: (err) => {
        this.releases = [];
        this.groupedReleases = [];
      },
    });
    // Mark current version as seen when user views this page
    try {
      const result = await firstValueFrom(this.releaseNoteService.markVersionAsSeen());
    } catch (error) {
      console.error('Error details:', JSON.stringify(error, null, 2));
    }
  }

  private groupByVersion(notes: ReleaseNoteDto[]): ReleaseGroup[] {
    const map = new Map<string, ReleaseGroup>();
    for (const note of notes) {
      const key = note.version ?? 'Unknown';
      if (!map.has(key)) {
        map.set(key, { version: key, date: note.date ?? '', notes: [] });
      }
      map.get(key)!.notes.push(note);
    }
    return Array.from(map.values());
  }
}
